import classes from "../../scss/ServiceTimeline.module.scss";
import { v4 as uuid } from "uuid";

export default function Timeline({ title, items }) {
  return (
    <section className={classes.timeline}>
      <div className={classes.timeline__title_wrapper}>
        <h2 className={classes.timeline__title}>
          <span></span>
          {title}
        </h2>
      </div>
      {items.map((item) => (
        <article className={classes.timeline__item_wrapper} key={uuid()}>
          <div className={classes.timeline__item_wrapper_layout}></div>
          <div className={classes.timeline__item}>
            <div className={classes.timeline__image}>
              <img
                src={item.image}
                alt={item.text}
                width={item.size}
                height={item.size}
              />
            </div>
            <p>{item.text}</p>
          </div>
        </article>
      ))}
    </section>
  );
}
